export default {
  header: 'Report Emailed',
  body: 'Due to the size and the time to process the download, we have emailed you the report.',
  CTA: 'Got it',
  modalWidth: '627px',
  icon: 'ALERT',
};
